export default "__VITE_ASSET___IZVJoW5__"